<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: '401',
})
</script>
<template>
  <el-result
    class="page-container__report backdrop"
    sub-title="未开通权限"
  >
    <template #icon>
      <el-image
        style="width: 90px;"
        :src="ErrorImage"
      />
    </template>
    <template #extra>
      <el-button
        v-blur
        size="small"
        :loading="isDisabled"
        @click="logoutHandle"
      >
        退出登录
      </el-button>
    </template>
  </el-result>
</template>

<script setup lang="ts" name="401">
  import { ref } from 'vue';
  import { useUserStore } from '@/store/user';
  import ErrorImage from '@/assets/images/error/401.png';
  import { getLogoutUrl } from '@/utils/index';

  const isDisabled = ref(false);
  const logoutHandle = async() => {
    isDisabled.value = true;
    const result:TypeObject = await useUserStore().logout().finally(() => { isDisabled.value = false; });
    location.href = getLogoutUrl(result.loginUrl || '');
  };
</script>
